







































import Vue from 'vue';
import { ErrorCodes } from '@ringana/errors';
import FetchError from '@/errors/fetch-error';
import { IProduct, IProductDetails } from '@/common/interfaces/products.interface';
import ProductHelper from '@/helpers/ProductHelper';
import AddToCartButton from '@/components/layout/buttons/AddToCartButton.vue';
import AddToCartButtonMobile from '@/components/layout/buttons/AddToCartButtonMobile.vue';
import EventListenerHelper from '@/helpers/EventListenerHelper';
import { IEventListener } from '@/common/interfaces/index.interface';
import { IMerchandiseItem } from '@/common/interfaces/merchandise.interface';
import PriceText from '@/components/newsingleproductpage/subcomponents/pricetext/PriceText.vue';
import { ILimitingObject } from '@/common/interfaces/limiting.interface';
import config from '../../../../config';

interface ISingleProductDetailsBar {
  addedToCart: boolean;
  loading: boolean;
  productHelper: typeof ProductHelper;
  visible: boolean;
  windowEventListeners: IEventListener[];
}

export default Vue.extend({
  name: `SingleProductDetailsBar`,
  components: {
    AddToCartButton,
    AddToCartButtonMobile,
    PriceText,
  },
  data(): ISingleProductDetailsBar {
    return {
      addedToCart: false,
      loading: false,
      productHelper: ProductHelper,
      visible: false,
      windowEventListeners: [],
    };
  },
  computed: {
    addToCartLabel(): string {
      if(!this.isProductComingSoon && !this.productInfo.soldOut) {
        return ``;
      }
      return this.isProductComingSoon ? this.$t(`products-overview:comingSoon`) : this.$t(`products-overview:soldOut`);
    },
    isProductComingSoon(): boolean {
      return this.productInfo.deliveryStatus?.replaceAll(` `, ``).toLowerCase() === `comingsoon`;
    },
    isProductUnavailable(): boolean {
      if(!this.productInfo.deliveryStatusId) {
        return false;
      }

      return config.unavailableDeliveryStatusIds.includes(this.productInfo.deliveryStatusId);
    },
  },
  props: {
    discountActive: {
      default: false,
      type: Boolean,
    },
    isPartner: {
      default: false,
      type: Boolean,
    },
    limiting: {
      required: true,
      type: Object as () => ILimitingObject,
    },
    productDetails: {
      required: true,
      type: Object as () => IProductDetails,
    },
    productInfo: {
      required: true,
      type: Object as () => IProduct,
    },
    selectedCartId: {
      required: true,
      type: Number,
    },
  },
  created() {
    this.windowEventListeners = [
      { callback: this.handleScroll, name: `resize` },
      { callback: this.handleScroll, name: `scroll` },
    ];
    EventListenerHelper.setUpEventListeners(this.windowEventListeners, window);
  },
  destroyed() {
    EventListenerHelper.teardownEventListeners(this.windowEventListeners, window);
  },
  methods: {
    async addItemToCart(): Promise<void> {
      this.loading = true;
      try {
        const merchandiseItem: IMerchandiseItem | null = await this.$cartService.addItemToCartWithProductInfo(this.productInfo, this.isPartner, 1, this.selectedCartId);
        if(merchandiseItem) {
          this.$emit(`open:merchandise-overlay`, merchandiseItem);
        }
        this.loading = false;
        this.addedToCart = true;
        setTimeout(() => {
          this.addedToCart = false;
        }, 2000);
      } catch (err) {
        if(err instanceof FetchError && err.errorCode === ErrorCodes.LIMITING_BOUNCER_ACTIVE) {
          window.scrollTo({ behavior: `smooth`, top: 0 });
        }
        this.loading = false;
      }
    },
    handleScroll(): void {
      const addToCartButton = document.querySelector(`.top-section .add-to-cart-button`) as HTMLDivElement | null;
      const blogSectionHeadline = document.querySelector(`.blog-section .blog-section__headline`) as HTMLDivElement | null;
      const singleProductDetailsBar = document.querySelector(`.single-product-details-bar`) as HTMLDivElement | null;

      if(addToCartButton && blogSectionHeadline && singleProductDetailsBar) {
        const positionTop = addToCartButton.getBoundingClientRect().y;
        const positionBottom = blogSectionHeadline.getBoundingClientRect().y;
        const positionSingleProductDetailsBar = singleProductDetailsBar.getBoundingClientRect().y;
        this.visible = positionTop < 0 && positionBottom > positionSingleProductDetailsBar;
      } else if(addToCartButton && !blogSectionHeadline && singleProductDetailsBar) {
        const positionTop = addToCartButton.getBoundingClientRect().y;
        this.visible = positionTop < 0;
      }

      const freshChat = document.querySelector(`#fc_frame`) as HTMLDivElement;
      if(freshChat) {
        freshChat.classList.add(`translate-freshchat`);

        if(this.visible) {
          freshChat.classList.add(`translate-freshchat--up`);
        } else {
          freshChat.classList.remove(`translate-freshchat--up`);
        }
      }
    },
  },
});
